exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".INlXl {\n  width: 200px;\n  height: 200px;\n  margin: 20px;\n  color: #BD9471;\n  cursor: pointer;\n  text-align: center;\n  text-transform: capitalize;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.INlXl ._3p0jY {\n  font-size: 16px;\n  padding-top: 20px;\n}\n", ""]);

// Exports
exports.locals = {
	"button": "INlXl",
	"label": "_3p0jY"
};